import { DirectionalHint } from "@fluentui/react";
import { CSSProperties } from "react";
import { SettingChoices, StepOrder } from "../consts";

export function getStepNumber(CurrentMode: SettingChoices): number {
    let tempNo: number = Object.keys(StepOrder).find((key: any) => StepOrder[key] === CurrentMode) as unknown as number;
    let stepNo = 1;
    if (tempNo) {
        stepNo = +tempNo
        return stepNo
    }
    else {
        return 1
    }
}

export function StoryToolTipText(storyStep: number, setting: SettingChoices, marketFilter: boolean): string {
    if (setting === "YoYTotal") {
        if (marketFilter) {
            if (storyStep === 1) {
                return ("All three markets were mostly moving in sync prior to COVID lockdowns.")
            }
            else if (storyStep === 2) {
                return ("Statewide restrictions saw most businesses and factories close. There was a shift to working and schooling from home where possible")
            }
            else if (storyStep === 3) {
                return ("The markets reached parity with each other again two months after the strict lockdown ended.")
            }
        }
        else if (!marketFilter) {
            if (storyStep === 1) {
                return ("Across the electricity network there is a net consumption decrease of around -4% from the previous year. This is a significant change in the context of electricity demand. especially as 2020 was colder than 2019.")
            }
            else if (storyStep === 2) {
                return ("The first lockdown saw an extreme low in April, while the second lockdown sees a similar low in August.")
            }
            else if (storyStep === 3) {
                return ("We can see a slow returs to normal as restrictions ease over time. This is in contrast to the immediate changes when restrictions were implemented at short notice.")
            }
        }

    }
    else if (setting === "YoYMarketRegion") {
        if (marketFilter) {
            if (storyStep === 1) {
                return ("During the first lockdown the similar restrictions between regions saw the different market types following similar growth or decline.")
            }
            else if (storyStep === 2) {
                return ("During the second lockdown regional businesses remained open unlike their metropolitan counterparts. Tourism however was virtually non-existant during this period in Regional Victoria.")
            }
        }
        else if (!marketFilter) {
            if (storyStep === 1) {
                return ("Lockdown restrictions saw Victoria split into two distinct regions with differing rules.")
            }
            else if (storyStep === 2) {
                return ("Regional Victoria had significantly fewer restrictions during Lockdown 2.")
            }
        }
    }
    else if (setting === "RawYearComparison") {
        if (marketFilter) {
            if (storyStep === 1) {
                return ("From this we can see that Residential consumption is far more sensitive to temperature than business or industrial consumption. The latter two market types remain relativley stable throughout the year.")
            }
            else if (storyStep === 2) {
                return ("It's a little tough to interpret the change between 2019 and 2020 when viewed like this. Let's look only at the difference between the years on the next visual.")
            }
        }
        else if (!marketFilter) {
            if (storyStep === 1) {
                return ("In a typical year Victoria generates approximately 26 million Megawatt-Hours (MWh) of electricity.")
            }
            else if (storyStep === 2) {
                return ("Generation is distributed across the year with peaks occuring during the hottest and coldest months.")
            }
        }
    }
    else if (setting === "Calendar") {
        if (storyStep === 1) {
            return ("This calendar shows the consumption each day over a two year period. Click on some of the public holidays below to investigate the year on year change in a little more detail.")
        }
        else if (storyStep === 2) {
            return ("Public holidays during the lockdown period exhibited significantly more overall consumption. Nearly all of which is from the residential sector.")
        }
    }
    return ""
}

export function IntroStoryTitle(storyStep: number, setting: SettingChoices) {
    return (`Test Title ${String.fromCodePoint(0x1F354)}`)
}

export function BubbleDirection(setting: SettingChoices, storyStep: number, mkFilter: boolean) {
    if (setting === "RawYearComparison") {
        if (!mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.bottomAutoEdge
            }
            else if (storyStep === 2) {
                return DirectionalHint.bottomRightEdge
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.topRightEdge
            }
            else if (storyStep === 2) {
                return DirectionalHint.topLeftEdge
            }
        }
    }
    else if (setting === "YoYTotal") {
        if (!mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.topRightEdge
            }
            else if (storyStep === 2) {
                return DirectionalHint.bottomCenter
            }
            else if (storyStep === 3) {
                return DirectionalHint.bottomLeftEdge
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.topCenter
            }
            else if (storyStep === 2) {
                return DirectionalHint.topRightEdge
            }
            else if (storyStep === 3) {
                return DirectionalHint.leftCenter
            }
        }
    }
    else if (setting === "YoYMarketRegion") {
        if (!mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.topLeftEdge
            }
            else if (storyStep === 2) {
                return DirectionalHint.bottomLeftEdge
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                return DirectionalHint.topCenter
            }
            else if (storyStep === 2) {
                return DirectionalHint.topCenter
            }
        }
    }
    else if (setting === "Calendar") {
        if (storyStep === 1) {
            return DirectionalHint.rightCenter
        }
        else if (storyStep === 2) {
            return DirectionalHint.rightCenter
        }
    }
    return DirectionalHint.topCenter
}

export function AnchorPost(setting: SettingChoices, storyStep: number, mkFilter: boolean): CSSProperties {
    let l: string = "70";
    let t: string = "50";
    if (setting === "RawYearComparison") {
        if (!mkFilter) {
            if (storyStep === 1) {
                l = "34";
                t = "35";
            }
            else if (storyStep === 2) {
                l = "68";
                t = "40";
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                l = "34";
                t = "57";
            }
            else if (storyStep === 2) {
                l = "74";
                t = "57";
            }
        }
    }
    else if (setting === "YoYTotal") {
        if (!mkFilter) {
            if (storyStep === 1) {
                l = "30.5";
                t = "50";
            }
            else if (storyStep === 2) {
                l = "36";
                t = "65";
            }
            else if (storyStep === 3) {
                l = "77";
                t = "64";
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                l = "30";
                t = "48";
            }
            else if (storyStep === 2) {
                l = "40";
                t = "63";
            }
            else if (storyStep === 3) {
                l = "85";
                t = "57";
            }
        }
    }
    else if (setting === "YoYMarketRegion") {
        if (!mkFilter) {
            if (storyStep === 1) {
                l = "29";
                t = "47";
            }
            else if (storyStep === 2) {
                l = "75";
                t = "65";
            }
        }
        else if (mkFilter) {
            if (storyStep === 1) {
                l = "30";
                t = "46";
            }
            else if (storyStep === 2) {
                l = "75";
                t = "59";
            }
        }
    }
    else if (setting === "Calendar") {
        if (storyStep === 1) {
            l = "75";
            t = "30";
        }
        else if (storyStep === 2) {
            l = "75";
            t = "60";
        }
    }
    return ({ position: "absolute", left: `${l}vw`, top: `${t}vh` })
}